/**
 * =============================================================================
 * mp-free-gift-with-purchase
 * =============================================================================
 * Handle client-side of the FGWP mechanism.
 * 
 * See also:
 * 
 * - fgwp-modal.liquid (the FGWP modal)
 * - fgwp.liquid (the FGWP product page messaging)
 * - fgwp-cart-offcanvas.liquid (the FGWP minicart cart messaging)
 * - fgwp-line-item (the line item messaging once the FGWP has been added)
 * 
 * This extension also requires:
 * 
 * - a Shopify Script to ensure all thresholds have been met and the 
*    shipping location is domestic, and that only 1 FGWP line item is added.
 * =============================================================================
 */

var FGWP = {
  data: {
    selectors: {
      threshold: "[data-mp-fgwp-threshold]",
      threshold_attribute: "data-mp-fgwp-threshold",

      product_ids: "[data-mp-fgwp-products]",
      product_ids_attribute: "data-mp-fgwp-products",

      to_spend_amount: ".mp-fgwp-to-spend-amount",
      to_spend_message: ".mp-fgwp-to-spend-message",

      add_buttons: ".mp-modal-fgwp-add",
      variant_select: ".mp-modal-fgwp-variant",

      met_threshold_message: ".mp-fgwp-threshold-met"
    },

    threshold: null,
    product_ids: [],
    user_country: null,
    included_countries: null,
    all_countries: true
  },

  /**
   * Setup the FGWP mechanism, listening for cart / minicart state, handling
   * FGWP modal interactions, etc.
   */
  onReady: function(){
    // FGWP not enabled
    if(document.querySelectorAll(".mp-fgwp-container").length == 0){
      return;
    }

    if(this.data.all_countries){
      this.setupOffer();
    } else {
      document.addEventListener('geodata:loaded', this.handleGeodataLoaded.bind(this));
    }

    // Handle the modal close event to remove the backdrop
    const myModalEl = document.getElementById('mp-modal-fgwp')
    myModalEl.addEventListener('hidden.bs.modal', event => {

      if(MP.Utilities.isProductPage()){
        const backdrop = document.querySelector(".modal-backdrop.fade.show");
        if (backdrop) {
            backdrop.remove();  // Removes the first matching element
        } 
      }
    })

    // Data attributes from mp-misc-free-gift-with-purchase.liquid
    this.data.threshold = parseInt(document.querySelector(this.data.selectors.threshold).dataset.mpFgwpThreshold);
    this.data.product_ids = JSON.parse(document.querySelector(this.data.selectors.product_ids).dataset.mpFgwpProducts);
    this.data.included_countries = document.querySelector("[data-fgwp-included-countries]").dataset.fgwpIncludedCountries.split(",");
  },

  handleGeodataLoaded: function(event) {
    var geodataJSON = event.detail.data;
    this.data.user_country = geodataJSON.country.iso_code;

    // Activate if applicable to this country
    if(this.data.included_countries.includes(this.data.user_country)){
      this.setupOffer();
    } else {
      console.log("[FGWP] Ignore - no locale match");
    }
  },

  setupOffer: function() {
    // Show messaging
    document.querySelector(".mp-fgwp-banner-enabled").classList.remove("d-none");

    // Handle cart update
    document.addEventListener('minicart:updated', this.handleCartUpdated.bind(this));

    // Handle events on the modal
    //$("[data-mp-fgwp-modal-option]").on("click", this.handleGiftVariantSelect.bind(this));
    document.querySelectorAll(this.data.selectors.add_buttons).forEach(element => {
      element.addEventListener("click", this.addFreeGift.bind(this));
    });
  },

  /**
   * Add the selected FGWP variant to the cart, if FR is found
   * @returns undefined
   */
  addFreeGift: function(e) {
    let closestTile = e.target.closest(".mp-modal-fgwp-tile");
    let selectedVariant = closestTile.querySelector(this.data.selectors.variant_select).value;

    if(selectedVariant == ""){
      return;
    }

    // Add it to the cart
    let productToAdd = {"id": selectedVariant, "quantity": 1, "properties": {"_fgwp": true}};
    MP.Extensions.Cart.add(productToAdd);

    // Hide the FGWP modal
    document.querySelector('#mp-modal-fgwp .btn-close').click();

    // Need to hide the second modal backdrop that gets added on the product page
    // when the FGWP modal is opened
    if(MP.Utilities.isProductPage()){
      const backdrop = document.querySelector(".modal-backdrop.fade.show");
      if (backdrop) {
          backdrop.remove();  // Removes the first matching element
      } 
    }
  },

  /**
   * Check the newly updated cart and update messaging / trigger the FGWP modal
   * if the threshold has been met.
   * 
   * @param {Event} e 
   * @returns undefined
   */
  handleCartUpdated: function(e) {
    var that = this;

    // No cart items - do nothing
    var cartItems = e.detail.cart?.items;
    if(cartItems === undefined) {
      return;
    }

    // Check if the cart already has the FGWP product
    var hasItem = false;
    cartItems.forEach(function(e){
      if(that.data.product_ids.includes(e.product_id)){
        if(e.properties !== null && e.properties['_fgwp']){
          hasItem = true;
        }
      }
    });

    // Exclude certain products from eligible total - gift cards
    var eligibleTotal = 0;
    eligibleTotal = cartItems.reduce(function(previousValue, e) {
      if(e.gift_card === true){
        return previousValue;
      } else {
        return previousValue + e.final_line_price
      }
    }, eligibleTotal);

    // Determine action based on cart state
    if(hasItem){
      // No longer required - updates dynamically from server in Liquid
    } else if (eligibleTotal >= this.data.threshold){
      // Show the prompt to add the FGWP 
      this.triggerPrompt();
    }
  },


  /**
   * Show the FGWP modal, if it's not already been shown (i.e. no cookie set)
   * 
   * @returns undefined
   */
  triggerPrompt: function() {      
    // Only show the FGWP modal once, when the cart initially goes over the threshold
    var notShown = Cookies.get('fgwp-prompt-shown') === undefined;
    if(notShown){
      setTimeout(function() {
        document.querySelector("#fgwp-model-open").click();
        Cookies.set('fgwp-prompt-shown', "true");
      }, 500);
    }
  }
};

export default FGWP;